import { negatedFilter } from '@/constants/meta'

/**
 * @param {Store}         context
 * @param {Store.commit}  context.commit
 * @param {Store.getters} context.getters
 * @param {object}        project
 */
const saveProject = ({ commit, getters }, project) => {
  const projectFromStore = getters.getProjectById(project.id)

  if (projectFromStore) {
    const newProject = {
      ...projectFromStore,
      ...project
    }

    commit('updateProject', newProject)
  } else {
    commit('addProject', project)
  }
}

/**
 * @param {Store}         context
 * @param {Store.commit}  context.commit
 * @param {Store.getters} context.getters
 * @param {object}        board
 */
const saveBoard = ({ commit, getters }, board) => {
  const boardFromStore = getters.getBoardById(board.id)

  if (boardFromStore) {
    const newBoard = {
      ...boardFromStore,
      ...board
    }

    commit('updateBoard', newBoard)
  } else {
    commit('addBoard', board)
  }
}

/**
 * @param {Store}         context
 * @param {Store.commit}  context.commit
 * @param {Store.getters} context.getters
 * @param {object}        style
 */
const saveStyle = ({ commit, getters }, style) => {
  const styleFromStore = getters.getStyleById(style.id)

  if (styleFromStore) {
    const newStyle = {
      ...styleFromStore,
      ...style
    }

    commit('updateStyle', newStyle)
  } else {
    commit('addStyle', style)
  }
}

/**
 * @param {Store}         context
 * @param {Store.commit}  context.commit
 * @param {Store.getters} context.getters
 * @param {object}        option
 */
const saveOption = ({ commit, getters }, option) => {
  const optionFromStore = getters.getOptionById(option.id)

  if (optionFromStore) {
    const newOption = {
      ...optionFromStore,
      ...option
    }

    commit('updateOption', newOption)
  } else {
    commit('addOption', option)
  }
}

/**
 * @param {Store}         context
 * @param {Store.commit}  context.commit
 * @param {Store.getters} context.getters
 * @param {object}        detail
 */
const saveDetail = ({ commit, getters }, detail) => {
  const detailFromStore = getters.getDetailById(detail.id)

  if (detailFromStore) {
    const newDetail = {
      ...detailFromStore,
      ...detail
    }

    commit('updateDetail', newDetail)
  } else {
    commit('addDetail', detail)
  }
}

/**
 * @param   {object} map
 * @param   {string} key
 * @param   {Array}  selected
 * @param   {Array}  filters
 *
 * @returns {object}
 */
const setNegatedFilter = (map, key, selected, filters) => {
  map[`${key}${negatedFilter.ENDPOINT}`] = filters
    .map(filter => filter.id)
    .filter(id => !selected.includes(id.toString()))

  return map
}

/**
 * @param   {Array}   filters
 * @param   {Array}   filterGroups
 * @param   {boolean} displayOptions
 *
 * @returns {object}
 */
const buildFilterQuery = (filters, filterGroups, displayOptions) => {
  if (!filters) {
    return {}
  }

  return Object.entries(filters).reduce((map, [key, value]) => {
    const filterGroupKey = displayOptions
      ? key.replace('style__', '').replace('options__', '')
      : key

    if (Object.keys(filterGroups).length === 0) {
      return map
    }

    if (value.includes(negatedFilter.ID)) {
      return setNegatedFilter(
        map,
        key,
        value,
        filterGroups[filterGroupKey].values
      )
    }

    if (Array.isArray(value)) {
      map[`${key}`] = value
    } else {
      map[key] = value
    }

    return map
  }, {})
}

export {
  saveProject,
  saveBoard,
  saveStyle,
  saveOption,
  saveDetail,
  setNegatedFilter,
  buildFilterQuery
}
